import { disManager, WebDisMetadata } from '@m43/core';
import { electronBridge, ElectronDexMetadata } from '../electron-bridge/electron-bridge';

export type DexMetadataNormalized = {
    deviceName: string;
};

let cached: DexMetadataNormalized | undefined;

export function normalize(
    data: ElectronDexMetadata | WebDisMetadata | undefined
): DexMetadataNormalized {
    return {
        deviceName:
            (data as ElectronDexMetadata | undefined)?.deviceName ??
            (data as WebDisMetadata | undefined)?.machineName ??
            '',
    };
}

export async function getDexMetadata(): Promise<DexMetadataNormalized> {
    if (cached) {
        return cached;
    }

    let data: ElectronDexMetadata | WebDisMetadata | undefined;

    if (electronBridge) {
        data = await electronBridge.getDexMetadata();
    } else {
        const disManagerResponse = await disManager.getMetadata();
        data = disManagerResponse?.data;
    }

    cached = normalize(data);
    return cached;
}
